import Vue from 'vue'
import loading from 'vuejs-loading-screen'

const parameterTheme = (new URLSearchParams(window.location.search)).get('theme')
const iconColor = parameterTheme === 'dark' ? '#fff' : '#000'

Vue.use(loading, {
    bg: parameterTheme === 'dark' ? '#000' : '#fff',
    size: 5,
    slot: '<i class="fas fa-globe fa-pulse fa-3x fa-fw" style="color:' + iconColor + '"></i>',
})